module.exports = __webpack_public_path__ + "img/lg_ring_y_i_1_null@3x.75ea6a42.png";